export type CarriedKind = 'role' | 'type';

const NOUNS: Readonly<Record<CarriedKind, readonly [string, string]>> = {
  role: ['rôle', 'rôles'],
  type: ['type', 'types'],
};

// The representatives a rule asks to carry roles or representative types (French), in the
// singular for one label, else in the plural, the labels being carried collectively.
export const representativesCarryingOf = (
  kind: CarriedKind,
  labels: readonly string[],
): string => {
  const [singular, plural] = NOUNS[kind];

  return labels.length > 1
    ? `un ou plusieurs représentants portant, ensemble, les ${plural} : ${labels.join(', ')}`
    : `au moins un représentant portant le ${singular} : ${labels.join(', ')}`;
};
